import { GET_SEARCH_DESCRIPTION } from "../../requests"

export const setResults = (results, category, searchValue) => ({
	type: '@@SEARCH_SET_RESULTS',
	results,
	category,
	searchValue
})

export const selectRow = (category, recordId) => ({
	type: '@@SEARCH_SELECT_ROW',
	category,
	recordId
})

export const setResultsMode = mode => ({
	type: '@@SEARCH_SET_RESULTS_MODE',
	mode
})

export const toggleSearching = searching => ({
	type: '@@SEARCH_TOGGLE_SEARCHING',
	searching
})

export const setSearchError = (searchError, category) => ({
	type: '@@SEARCH_SET_SEARCH_ERROR',
	searchError,
	category
})

export const clearSearchError = category => ({
	type: '@@SEARCH_CLEAR_SEARCH_ERROR',
	category
})

export const getSearchDescription = category => dispatch => {
	return new Promise(resolve => {
		GET_SEARCH_DESCRIPTION(category, description => {
			dispatch({
				type: '@@SEARCH_SET_DESCRIPTION',
				category,
				description
			});
			resolve(description);
		})
	})
}

export const setSort = ({category, sortBy, sortByDirection}) => dispatch => {
	return new Promise(resolve => {
		dispatch({
			type: '@@SEARCH_SET_SORT',
			category,
			sortBy,
			sortByDirection
		});
		resolve();
	})
}

export const setActiveCategory = category => dispatch => {
	dispatch({
		type: '@@SEARCH_SET_ACTIVE_CATEGORY',
		category
	})
	dispatch({
		type: 'SET_CURRENT_CATEGORY',
		category
	})
}

export const invalidateAllCategoryCaches = () => dispatch => {
	dispatch({
		type: '@@SEARCH_INVALIDATE_CACHE'
	})
}



// WEBPACK FOOTER //
// ./src/components/Search/SearchActions.js